<form *ngIf="formGroup" [formGroup]="formGroup">
  <div>
    <mat-form-field>
      <input matInput #paidOn placeholder="支払日" name="paidOn" formControlName="paidOn" [max]="maxDate"
        [matDatepicker]="paidOnDatepicker" (focus)="paidOnDatepicker.open()" required>
      <mat-datepicker #paidOnDatepicker></mat-datepicker>
      <mat-datepicker-toggle matSuffix [for]="paidOnDatepicker"></mat-datepicker-toggle>
      <button mat-button *ngIf="!readonly && paidOn.value" matSuffix mat-icon-button (click)="clear('paidOn')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <input matInput #supplierName placeholder="お店" name="supplierName" formControlName="supplierName"
        [matAutocomplete]="auto" required>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-optgroup *ngIf="predictions && !supplierName.value" label="もしかして">
          <mat-option *ngFor="let prediction of predictions" [value]="prediction.tagName">
            <div fxLayout="row" fxLayoutAlign="space-between">
              <div>{{prediction.tagName}}</div>
              <div>{{prediction.probability | percent:'0.1-1'}}</div>
            </div>
          </mat-option>
        </mat-optgroup>
        <mat-optgroup label="入力履歴">
          <mat-option *ngFor="let supplier of filteredSuppliers$ | async" [value]="supplier.supplierName">
            {{supplier.supplierName}}
          </mat-option>
        </mat-optgroup>
      </mat-autocomplete>
      <button mat-button *ngIf="!readonly && supplierName.value" matSuffix mat-icon-button
        (click)="clear('supplierName')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <mat-form-field>
    <mat-label>分類</mat-label>
    <mat-select [compareWith]="compareFn" name="category" formControlName="category" required>
      <mat-option *ngFor="let category of categories$ | async" [value]="category">
        {{category.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div>
    <mat-form-field>
      <input matInput #amount placeholder="金額" name="amount" formControlName="amount" required>
      <button mat-button *ngIf="!readonly && amount.value" matSuffix mat-icon-button (click)="clear('amount')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <mat-form-field>
    <mat-label>支払人</mat-label>
    <mat-select [compareWith]="compareFn" name="paidBy" formControlName="paidBy" required>
      <mat-option *ngFor="let user of users$ | async" [value]="user">
        {{user.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div>
    <mat-form-field>
      <input matInput #notes placeholder="メモ" name="notes" formControlName="notes">
      <button mat-button *ngIf="!readonly && notes.value" matSuffix mat-icon-button (click)="clear('notes')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field *ngIf="archived">
      <input matInput placeholder="精算日" name="archivedOn" type="date" formControlName="archivedOn">
    </mat-form-field>
  </div>
</form>